export const ColorUtil = {
  rgba2hex: (rgba: string) => {
    const match = rgba.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
    );

    return match
      ? `#${match
          .slice(1, 4)
          .map(n => Number.parseInt(n, 10).toString(16).padStart(2, '0'))
          .join('')}${
          match[4] && Number.parseFloat(match[4]) < 1
            ? Math.round(Number.parseFloat(match[4]) * 255)
                .toString(16)
                .padStart(2, '0')
            : ''
        }`
      : undefined;
  },
};
